export default "__VITE_ASSET__CvaNiD0w__"